import PropTypes from 'prop-types';
import React from 'react';

import CodeEditor from 'components/form/CodeEditor';

const AdvancedTab = ({ disabled, value, handleChangeContent }) => <>
  <CodeEditor
    disabled={disabled}
    readOnlyMessage='You can not edit the content in version view.'
    name="content"
    value={value}
    className='h-[40vh]'
    onChange={handleChangeContent}
    language="html"
  />
</>

AdvancedTab.propTypes = {
  value: PropTypes.string,
  show: PropTypes.bool,
  handleChangeContent: PropTypes.func,
};

export default AdvancedTab;
